const getFirebaseConfig = () => {
  const { REACT_APP_RELEASE_CHANNEL } = process.env;

  switch (REACT_APP_RELEASE_CHANNEL) {
    case "staging": {
      return {
        apiKey: "AIzaSyAcZmff7smxmwvrDPGhl9XzfVuzm8ZRGhU",
        authDomain: "kudzu-usa-staging.firebaseapp.com",
        projectId: "kudzu-usa-staging",
        storageBucket: "kudzu-usa-staging.appspot.com",
        messagingSenderId: "487088368746",
        appId: "1:487088368746:web:b6456b86f166009b64ae13",
        measurementId: "G-KW14T2FWH2",
      };
    }
    case "prod": {
      return {
        apiKey: "AIzaSyCIlPYL2AYSwAVtP6sgkXd3jyBSXT4Rzg8",
        authDomain: "kudzu-usa-prod.firebaseapp.com",
        projectId: "kudzu-usa-prod",
        storageBucket: "kudzu-usa-prod.appspot.com",
        messagingSenderId: "296947342003",
        appId: "1:296947342003:web:f76e4a5254160972892ec6",
        measurementId: "G-BXNN5NDKGN",
      };
    }
    default: {
      return {
        apiKey: "AIzaSyDTzx0pRDodTxjA5OxEyezmmF_twcxmGyU",
        authDomain: "kudzu-usa-dev.firebaseapp.com",
        databaseURL: "https://kudzu-usa-dev-default-rtdb.firebaseio.com",
        projectId: "kudzu-usa-dev",
        storageBucket: "kudzu-usa-dev.appspot.com",
        messagingSenderId: "873827156163",
        appId: "1:873827156163:web:d98f2cc4348d279e356276",
        measurementId: "G-SX82Y3JMCN",
      };
    }
  }
};

const firebaseConfig = getFirebaseConfig();

export default firebaseConfig;
